import { UserId } from '@business/entities/account';
import { ChecklistId, ChecklistResponse, CompactChecklistResponse, ChecklistStepResponse } from '@business/entities/checklist';
import { TeamId } from '@business/entities/team';
import { Endpoint } from '../endpoint';

export function fetchChecklists(checklistId?: ChecklistId) {
  return Endpoint.get<CompactChecklistResponse[]>('@gc/checklist', { params: { checklistId } });
}

export function fetchChecklist(id: ChecklistId) {
  return Endpoint.get<ChecklistResponse>(`@gc/checklist/checklist/${id}`);
}

export function createChecklist(data: Partial<ChecklistResponse>) {
  return Endpoint.post<ChecklistResponse>(`@gc/checklist/create`, { data });
}

export function updateChecklist(id: ChecklistId, data: Partial<ChecklistResponse>) {
  return Endpoint.patch<ChecklistResponse>(`@gc/todo-checklist/${id}`, { data });
}

export function setComplete(id: string, complete: boolean) {
  return Endpoint.post<ChecklistResponse>(`@gc/checklist/todo-complete/${id}`, { data: { complete } });
}

export function toggleStep(id: number, complete: boolean) {
  return Endpoint.post<ChecklistResponse>(`@gc/checklist/toggle/${id}`, { data: { complete } });
}

export function search(id: UserId | TeamId) {
  return Endpoint.get<CompactChecklistResponse[]>(`@gc/checklist/search`, { params: { id } });
}

export function createChecklistSection(id: ChecklistId, name: string) {
  return Endpoint.post<void>(`@gc/checklist/section/${id}`, { data: { name } });
}

export function deleteChecklistStep(id: number) {
  return Endpoint.delete<void>(`@gc/checklist/step/${id}`);
}

export function createChecklistStep(ChecklistTemplateId: ChecklistId, id: number, data: Partial<ChecklistStepResponse>, parentStepId?: number) {
  data = { ...data, ChecklistTemplateId, parentStepId };
  return Endpoint.post<void>(`@gc/checklist/step/${id}`, { data });
}

export function updateAssignne(type: string, id: number | string, items: string[]) {
  return Endpoint.post<ChecklistResponse>(`@gc/checklist/assignee`, { data: { type, id, items } });
}

export function updateChecklistStep(id: number, data: Partial<ChecklistStepResponse>) {
  return Endpoint.patch<void>(`@gc/checklist/step/${id}`, { data });
}
